import networkService from '../Network/NetworkManager';
import APPURL from '../Constants/URLConstants';

export const getListings = async ({page, search, setIsListingLoading}) => {
  setIsListingLoading(true);

  const searchQuery = search ? `&search_key=${search}` : '';
  const responseJson = await networkService.networkCall(
    APPURL.URLPaths.listings + `${page}&per_page=100${searchQuery}`,
    'get',
    '',
    '',
  );
  setIsListingLoading(false);
  return responseJson.data;
};
